// @ts-ignore
import { html, strMap } from 'fxjs/es';
import { MShopCoreTmplS } from '../../../../../Core/S/Tmpl/module/MShopCoreTmplS.js';
import { PartialMembership } from '@services/MarppleShop/features/Membership/type';
import { MEMBERSHIP_SIGNUP_KLASS, MEMBERSHIP_TOOLTIP_KLASS } from '../../constant';
import { font } from '@services/MarppleShop/shared/typography';
import { ButtonFactory } from '@services/MarppleShop/shared/components/atoms/ButtonFactory/ButtonFactory.ts';
import { UtilS } from '@modules/Util/S/Function/module/UtilS';

export const makeMembershipTagHtml = (
  creator_name: string,
  memberships: PartialMembership[],
  is_mobile = false,
): string => {
  return html`
    <div class="pd-membership-tag ${font('14_medium')}">
      본 상품은
      ${is_mobile
        ? '멤버십'
        : html`<span class="${font('14_bold')}">&nbsp;${creator_name}&nbsp;멤버십&nbsp;</span>`}
      회원만 구매하실 수 있어요.&nbsp;${membershipTagToolTip(memberships)}
    </div>
  `;
};

const membershipTagToolTip = (memberships: PartialMembership[]): string => {
  return html`
    <span class="tooltip-icon">${MShopCoreTmplS.infoIcon()}</span>
    <div class="tooltip-container mps2-tooltip ${MEMBERSHIP_TOOLTIP_KLASS}" role="tooltip">
      <h4>혜택이 포함된 플랜</h4>
      <br />
      <p>
        ${strMap(({ displayName }: PartialMembership) => {
          return `·&nbsp;&nbsp;${displayName}<br />`;
        }, memberships)}
      </p>
      <br />
      <p>구매 수량이 제한된 상품은 가입 플랜 수와 관계없이 1인당 구매 가능 수량에 한해 구매하실 수 있어요.</p>
    </div>
  `;
};

export const makeMembershipSignupButtonHtml = (domain_name: string, isApp?: boolean) => {
  return html`
    <div class="pd-submit__btns">
      ${UtilS.htmlIf2(
        isApp,
        () =>
          ButtonFactory.create('SOLD_OUT', {
            klass: `pd-submit__btn app`,
            label: ET('cta::membership_app'),
            attr: {
              [`data-domain_name`]: domain_name,
              disabled: 'true',
            },
          }).toHtmlSSR(),
        () =>
          ButtonFactory.create('MEMBERSHIP', {
            klass: `pd-submit__btn ${MEMBERSHIP_SIGNUP_KLASS}`,
            attr: {
              [`data-domain_name`]: domain_name,
            },
          }).toHtmlSSR(),
      )}
    </div>
  `;
};
